import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H1 } from '@/@bothrs-ui/web/components/typography/Heading'
import { mixpanel } from '@/mixpanel'
import { useServer } from '@/modules/healthblocks/ServerProvider'
import { ExternalSourceCard } from '@/modules/shared/components/source-card/external-source-card/ExternalSourceCard'
import { openUrl } from '@/utils/external-resources'
import { useTranslated } from '@/utils/translation'

export const EmergencyCareContent = () => {
  const theme = useTheme()
  const server = useServer()

  const emergencyRoom = useTranslated('emergency-room.url')
  const doctorOnCall = useTranslated('doctor-on-call.url')

  const handleEmergencyRoom = () => {
    mixpanel.track(`emergency_open_er_${server?.tenant ?? 'azmm'}`)
    openUrl(emergencyRoom)
  }

  const handleDoctorOnCall = () => {
    mixpanel.track('emergency_open_doctor_on_call')
    openUrl(doctorOnCall)
  }

  const handleEmergencyCall = () => {
    mixpanel.track('emergency_call_112')
    const number = '112'
    openUrl(`tel:${number}`)
  }

  return (
    <FlexColumn gap={theme.UI.Spacing.Space4}>
      <H1 noMargin>
        {t({
          id: 'care-question.emergency.title',
          message: 'Neem contact op met je huisarts voor dringende medische hulp',
        })}
      </H1>

      <P type='BodyMediumRegular' style={{ fontWeight: 400 }}>
        {t({
          id: 'care-question.emergency.description',
          message: 'Kan je je huisarts niet bereiken? Probeer een van onderstaande opties.',
        })}
      </P>

      {doctorOnCall && (
        <ExternalSourceCard
          title={t({
            id: 'care-question.emergency.general-practitioner.title',
            message: 'Zoek een huisarts van wacht',
          })}
          description={t({
            id: 'care-question.emergency.general-practitioner.description',
            message: 'Een huisarts van wacht is bereikbaar buiten de normale werkuren.',
          })}
          onClick={handleDoctorOnCall}
        />
      )}

      {emergencyRoom && (
        <ExternalSourceCard
          title={t({
            id: 'care-question.emergency.er.title',
            message: 'Kom naar de spoedafdeling',
          })}
          description={t({
            id: 'care-question.emergency.er.description',
            message: 'Je kan zo nodig op eigen initiatief naar de spoedafdeling komen.',
          })}
          onClick={handleEmergencyRoom}
        />
      )}

      <ExternalSourceCard
        title={t({
          id: 'care-question.emergency.112.title',
          message: 'Bel 112',
        })}
        description={t({
          id: 'care-question.emergency.112.description',
          message:
            'Indien je niet zelf naar de spoedafdeling kan komen en toch dringende medische hulp nodig hebt: bel 112.',
        })}
        onClick={handleEmergencyCall}
      />
    </FlexColumn>
  )
}
